module.exports = __webpack_public_path__ + "static/media/home_4.88e35e1b.jpg";